<template>
  <div id="startscreen">
      <router-link to="/start" @click.native="clearGame" class="del">
        Spielstand löschen und neu Anfangen.
      </router-link>
    <router-link to="/0">
       <span>Marco's Schrein</span>
       <span class="sub">Click to start</span>
    </router-link>
       <span class="desc">Ich grüsse Sie, Livio! Dieses Game ist eine Herausforderung für den Träger des Bannschwertes! Finde alle Gegenstände und erlange zutritt in den heiligen Schrein von Marco und erlange das Gamer-Diplom! Viel Spass bei dieser Prüfung der Stufe 3!</span>
  </div>
</template>
<script>

export default {
  name: 'startscreen',
  methods:{
    clearGame(){
      window.localStorage.clear()
      this.$router.go({
        path: '/start',
        force: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  span{
    text-transform: uppercase;
    font-size: 150px;
    line-height: 220px;
    position: absolute;
    color:red;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -30%) scale(0.9);
    text-shadow: 5px 5px white;
    text-align: center;
  }
  .desc{
    padding-top: 45%;
    font-size: 25px;
    line-height: 45px;
    text-shadow: 2px 2px white;
    width: 95%;
    pointer-events: none;
  }
  .sub{
    padding-top: 5%;
    font-size: 25px;
    text-shadow: 2px 2px white;
    z-index: 100;
  }
  .del{
    position: absolute;
    top: -48px;
    color:white;
    text-decoration: none;
    &:hover{
      color:red;
    }
  }


</style>
